import React, { useState, useRef, useEffect } from "react";
import { Mask } from 'antd-mobile'
import day from 'dayjs'
import './index.scss'

interface AiTabBarProps {
    tabsData?: Array<any>
    activeId?: number
    onChange?: (index: number, item: any, date: Array<string>) => void
    onChangeDate?: (index: number, item: any, date: Array<string>, _dayNum:number) => void
    dayNum?: number //近多少天 
    isDate?:boolean //是否显示选择日期
    _style?:object,
    disableList?:any
    dates?: any
    children?:React.ReactNode | string // 自定义菜单元素
}

const _dates = ['近7天', '1个月', '2个月', '3个月', '4个月', '5个月', '6个月', '一年']

const AiTabBar: React.FC<AiTabBarProps> = ({ isDate = true, dates = _dates, dayNum = 0, _style = {}, tabsData = [], children = '', ...props }) => {
    const tabsEl = useRef<any>(null)
    const [activeId, setactiveId] = useState(props?.activeId || 0)
    const [clientY, setclientY] = useState(0)
    const [visible, setVisible] = useState(false)
    const [dateName, setDateName] = useState(dates[dayNum])
    const [scLeft, setLeft] = useState(0)
    const [dateList, setDateList] = useState([day(+new Date()).subtract(dayNum === 0 ? (7 - 1) : dayNum === 7 ? 365 : dayNum * (30 - 1), 'day').format('YYYY.MM.DD'), day(new Date()).format('YYYY.MM.DD')])
    const handleChangeDate = (even) => {
        const { clientY } = even
        setVisible(true)
        setclientY(clientY)
    }
    useEffect(() => {
        setactiveId(props?.activeId || 0)
    },[props.activeId])
    const handleChangeDateItem = (index, item) => {
        if (!item) {
            return
        }
        let startDate:any = null
        let _dayNum = 0
        switch (index) {
            case 0:
                startDate = day(+new Date()).subtract(7 - 1, 'day').format('YYYY.MM.DD')
                _dayNum = 6
                break
            case 7:
                startDate = day(+new Date()).subtract(365, 'day').format('YYYY.MM.DD')
                _dayNum = 365
                break
            default:
                startDate = day(+new Date()).subtract(index * 30 - 1, 'day').format('YYYY.MM.DD')
                _dayNum = index * 30 - 1
                break
        }
        const dateList = [startDate, day(new Date()).format('YYYY.MM.DD')]
        setDateList(dateList)
        setVisible(false)
        setDateName(item)
        if (props?.onChangeDate) {
            props.onChangeDate(index, item, dateList, _dayNum)
        }
    }
    const handleChangeItem = (index, item, e) => {
        if( activeId === index ) {
            return
        }
        let offsetLeft = e.target.offsetLeft
        const offsetWidth = tabsEl.current.offsetWidth
        const left = offsetLeft - (offsetWidth / 2)
        if( left > 0 ) {
            tabsEl.current.scrollLeft = left
        }
        if (props?.onChange) {
            props.onChange(index, item, dateList)
        }
        if( props?.disableList && !!props?.disableList?.length && props.disableList.includes(index) ) {
            return
        }
        setactiveId(index)
    }
    return <div>
        <div className="tabs-wrapper">
            {!children && <div className="tabs-wrapper-item" ref={tabsEl} data-stop='stop'> 
                {tabsData.map((item, index) => (
                    <p data-stop='stop' className={`${activeId === index ? 'active' : ''}`} style={{..._style}} key={index} onClick={e => handleChangeItem(index, item, e)}>{item}</p>
                ))}
            </div>}
            {!!children && children}
            {isDate && <div className="tabs-wrapper-date" onClick={handleChangeDate}>
                <div>{dateName} <b></b> </div>
            </div>}
        </div>
        <Mask visible={visible} style={{'--z-index':'9999'}} onMaskClick={() => setVisible(false)}>
            <div className="choose-wrapper-date" style={{ right:'.2667rem', top: clientY + 'px' }}>
                {dates.map((item, index) => (
                    <div className="choose-wrapper-date-item" key={index} onClick={() => handleChangeDateItem(index, item)}>{item}</div>
                ))}
            </div>
        </Mask>
    </div>
}

export default AiTabBar

export const MaskType = ({visible = false, clientY = 0, dataList, ...props }) => {
    return <Mask visible={visible} style={{'--z-index':'9999'}} onMaskClick={() => props?.onMaskClick && props.onMaskClick()}>
        <div className="choose-wrapper-date" style={{ width:'95%', right:'50%',transform:'translateX(50%)', top: (clientY + 40) + 'px' }}>
            {dataList.map((item, index) => (
                <div style={{'flex':'33.33% 0 0','padding':'0 .4rem'}} key={index} onClick={() => props?.handleChangeDateItem && props.handleChangeDateItem(index, item)}>{item.typeName}</div>
            ))}
        </div>
    </Mask>
}